export function useLocale() {
  const { $i18n } = useNuxtApp();

  const { locale } = $i18n.global;

  return computed(() => ({
    iso: locale.value,
    mapped: reverseLocaleMap(locale.value),
  }));
}
